import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllUserRoles } from "../server/rolesAllApi";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const EditCourseCommunity = () => {
  const [formValues, setFormValues] = useState({
    title: "",
    community_link: "",
    department_id: "",
    level_id: "",
    course_id: "",
    batch_id: "",
  });
  const location = useLocation();
  const communityToEdit = location.state?.item;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [courseCategories, setCourseCategories] = useState([]);
  const [course, setCourse] = useState([]);
  const [batches, setBatches] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [touched, setTouched] = useState(false);
  const [roles, setRoles] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();

  useEffect(() => {
    if (communityToEdit) {
      // console.log("traderrrrrr info: ", communityToEdit);

      setFormValues({
        title: communityToEdit?.title,
        community_link: communityToEdit?.link_url,
        department_id: communityToEdit?.departmentData?._id,
        level_id: communityToEdit?.levelData?._id,
        course_id: communityToEdit?.courseData?._id,
        batch_id: communityToEdit?.batchData?._id
      });
      setLoading(false); // Stop loading after setting form state
    } else {
      setError("No tutor data found.");
      setLoading(false);
    }
  }, [communityToEdit]);

  useEffect(() => {
    const fetchdepartment = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setDepartments(response?.data?.data);
        // console.log(response?.data?.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchdepartment();
  }, []);

  useEffect(() => {
    const fetchCourseCategory = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-category-bydept/${formValues.department_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourseCategories(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchCourseCategory();
  }, [formValues.department_id]);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Courses/${formValues.department_id}/${formValues.level_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourse(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchCourse();
  }, [formValues.level_id, formValues.department_id]);

    useEffect(() => {
      const fetchBatches = async () => {
        try {
          const token = localStorage.getItem("token");
          if (!token) {
            // console.log("Access required");
            return;
          }
          const response = await axios.get(
            `${process.env.REACT_APP_INSTITUTION_BASEURL}/getallbatchcourseid/${formValues.course_id}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          setBatches(response.data.data);
          // console.log(response.data);
        } catch (error) {
          // console.log(error);
        }
      };
      fetchBatches();
    }, [formValues.course_id]);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      // console.log(
      //   "REACT_APP_INSTITUTION_BASEURL:: ",
      //   process.env.REACT_APP_INSTITUTION_BASEURL
      // );
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/edit-course-community/${communityToEdit._id}`,
        formValues,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setSnackbarMessage("Updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/course-community-list");
        }, 2000);
      }
    } catch (err) {
      setLoading(false);

      // Check for 400 status error
      if (err.response && err.response.status === 400) {
        setSnackbarMessage("Please fill out all required fields...");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage(
          "Failed to update. Please try again"
        );
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={handleFormSubmit}>
              <div className="mb-20">
                <label
                  htmlFor="title"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Title
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="title"
                  required
                  placeholder="Enter Title"
                  value={formValues.title}
                  onChange={(e) => {
                    
                    const value = e.target.value;

                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        title: value,
                      });
                    }
                  }}
                  onBlur={() => setTouched(true)} // Mark as touched when losing focus
                />
              </div>

              <div className="mb-20">
                <label
                  htmlFor="community_link"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  URL<span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="community_link"
                  required
                  placeholder="Enter URL"
                  value={formValues.community_link}
                  onChange={(e) =>
                    {
                      const value = e.target.value;
                      if (value === "" || value.trim() !== "") {
                    setFormValues({
                      ...formValues,
                      community_link: e.target.value,
                    });
                  }}}
              
                />
              </div>
              <div className="mb-20">
                <label
                  htmlFor="depart"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="depart"
                  required
                  value={formValues.department_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      level_id:"",
                      course_id:"",
                      department_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a Department
                  </option>
                  {departments.map((department) => (
                    <option key={department._id} value={department._id}>
                      {department.department_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Course Category (Level) */}
              <div className="mb-20">
                <label
                  htmlFor="courseCategory"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Level
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  required
                  className="form-control radius-8 form-select"
                  id="courseCategory"
                  value={formValues.level_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      level_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a Level
                  </option>
                  {courseCategories.map((courseCategory) => (
                    <option key={courseCategory._id} value={courseCategory._id}>
                      {courseCategory.courseCategoryName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Course */}
              <div className="mb-20">
                <label
                  htmlFor="course"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Course
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  required
                  className="form-control radius-8 form-select"
                  id="course"
                  value={formValues.course_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      course_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a course
                  </option>
                  {course.map((courses) => (
                    <option key={courses._id} value={courses._id}>
                      {courses.coursename}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-20">
                <label
                  htmlFor="batch"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Batch
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  required
                  className="form-control radius-8 form-select"
                  id="batch"
                  value={formValues.batch_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      batch_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a batch
                  </option>
                  {batches.map((batch) => (
                    <option key={batch._id} value={batch._id}>
                      {batch.batch_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/course-community-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  // onClick={handleFormSubmit}
                >
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditCourseCommunity;
